//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/v2";
//#endregion

const DialogAlertConfirmDeleteSpace = ({
    dialog, confirm
}) => {
    return (
        <DialogAlertAction
            dialog={dialog}
            widthContent="100%"
            variant="secondary"
            title="¿Deseas eliminar el espacio?"
            content="Recuerda que al eliminar el espacio, desaparecerá del campus
            y no podrás editarlo.">
            <CustomButton
                variant="secondary"
                width="120px"
                text="No, cancelar"
                onClick={dialog.hide}/>
            <CustomButton
                width="120px"
                text="Sí, eliminar"
                onClick={confirm}/>
        </DialogAlertAction>
    );
}

export default DialogAlertConfirmDeleteSpace;